module.exports = __webpack_public_path__ + "img/todo-crowdl.749c9174.png";